var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"disabled":_vm.isShow,"effect":"dark","content":_vm.tooltipContent,"placement":"top","popper-class":"ai-sound-effect-tooltip"}},[_c('div',{staticClass:"icon-container"},[_c('iconpark-icon',{class:{current: _vm.current},attrs:{"name":_vm.name,"size":_vm.size}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }